import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { dispatcher } from 'dispatcher';

import { usePortletConfig } from 'js/components/system/Portlet';

import { useGamesSelector } from 'js/app/components/main/Games/store/context';

export const useGameEventDispatch = () => {
    const { pathname } = useLocation();
    const { portletId } = usePortletConfig();
    const { feed, activeCategory } = useGamesSelector();

    return useCallback(({ name, data = {} }) => {
        dispatcher.dispatch(name, {
            portletId,
            page: pathname,
            feedName: feed.name,
            categoryName: activeCategory.name,
            ...data
        });
    }, [activeCategory.name, feed.name, pathname, portletId]);
};
